import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as prismicActions from '../redux/actions/prismicActions';
import PrismicReact from 'prismic-reactjs';
import MetaTags from '../components/MetaTags';
import BgPattern from '../components/BgPattern'
import LoadingOverlay from '../components/LoadingOverlay';
import htmlSerializer from '../plugins/htmlSerializer';

class ErrorPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      doc: null,
      notFound: false,
    }
  }

  componentWillMount() {
    this.findPage(this.props)
  }

  componentWillReceiveProps(props) {
    this.findPage(props)
  }

  findPage(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'error_page') 

      this.setState({doc})
      props.getActiveDoc(doc)
    }
  }

  render() {
    if(this.state.doc) {
      let {
        prismicCtx
      } = this.props
      const document = this.state.doc
      const docData = document.data
      // console.log(document)
      window.document.querySelector('html').classList.add('ready');
      return (
        <main data-wio-id={document.id} id={document.id} className={`page page-error`}>
          <MetaTags 
            title={`${docData.meta_title ? docData.meta_title : '404 Error'}`}
            description={`${docData.meta_description ? docData.meta_description : "Open your mind and find your state of mindfulness, enhanced by our low THC, high CBD strains of cannabis. At AltaVie, we're all about elevating the way you live."}`}
          />
          <section className="section-error section-coming">
            <BgPattern/>
            <div className="container container-medium">
              <div className="title-container">
                {PrismicReact.RichText.render(docData.title)}
                {PrismicReact.RichText.render(docData.subtitle)}
              </div>
              {PrismicReact.RichText.render(docData.content, prismicCtx.linkResolver, htmlSerializer)}
              <Link to={PrismicReact.Link.url(docData.button_link, prismicCtx.linkResolver)} className="button button-large">{docData.button_name}</Link>
            </div>
          </section>
        </main>
      )
    } 
    return <LoadingOverlay />
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  activeDoc: state.prismic.activeDoc,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getActiveDoc: prismicActions.getActiveDoc, },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage)


// WEBPACK FOOTER //
// ./src/pages/ErrorPage.js